import {
  ListRecoverRegistrationsInputSchema,
  ListRecoverRegistrationsResultSchema,
} from "@redotech/redo-model/recover/registration-dashboard";

export const listRecoverRegistrations = {
  name: "listRecoverRegistrations" as const,
  input: ListRecoverRegistrationsInputSchema,
  output: ListRecoverRegistrationsResultSchema,
};
